import {PillType} from '@Components/pill/pill.types';
import {PostPublishStatus} from '@Libraries/social-media-publish-status.library';

export interface PostPublishStatusPillProps {
  status: PostPublishStatus;
  className?: string;
  'data-testid'?: string;
}

export const POST_PUBLISH_STATUS_PILL_TYPES: Readonly<Record<PostPublishStatus, PillType>> = {
  [PostPublishStatus.PUBLISHING]: PillType.BRAND,
  [PostPublishStatus.PUBLISHED]: PillType.SUCCESS,
  [PostPublishStatus.SCHEDULING]: PillType.BRAND,
  [PostPublishStatus.SCHEDULED]: PillType.BRAND,
  [PostPublishStatus.SAVING_DRAFT]: PillType.NEUTRAL,
  [PostPublishStatus.SAVED_DRAFT]: PillType.NEUTRAL,
  [PostPublishStatus.FAILED]: PillType.ERROR,
};

export const POST_PUBLISH_STATUS_PILL_GLYPHS: Readonly<Record<PostPublishStatus, string>> = {
  [PostPublishStatus.PUBLISHING]: '',
  [PostPublishStatus.PUBLISHED]: 'icon-check-filled',
  [PostPublishStatus.SCHEDULING]: '',
  [PostPublishStatus.SCHEDULED]: 'icon-calendar',
  [PostPublishStatus.SAVING_DRAFT]: '',
  [PostPublishStatus.SAVED_DRAFT]: 'icon-save',
  [PostPublishStatus.FAILED]: 'icon-exclamation-triangle',
};
